export default __webpack_public_path__ + "static/media/icon_21.ccf5affb.png";